import React from "react";
import {
  PRIVACY_VISIBILITY_OPTIONS,
  normalizePrivacyVisibility,
} from "../../../../features/privacy/definitions";

const DEFAULT_VISIBILITY_LABELS = {
  VISIBLE: "Visible",
  NOT_VISIBLE: "Not visible",
  UNSET: "No preference set",
};

const PrivacyVisibilityCard = ({ t, childKey, visibility, setVisibility }) => (
  <fieldset className="m-0 border-t border-slate-200/80 px-4 py-3 dark:border-slate-700/80">
    <legend className="sr-only">
      {t("privacy.visibility.title", { defaultValue: "Visibility" })}
    </legend>

    <p className="m-0 mb-2 text-[0.78rem] font-black uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">
      {t("privacy.visibility.title", { defaultValue: "Visibility" })}
    </p>

    <div className="grid gap-1">
      {PRIVACY_VISIBILITY_OPTIONS.map(({ value, labelKey }) => {
        const checked = normalizePrivacyVisibility(visibility) === value;

        return (
          <label
            key={value}
            className={`grid min-h-10 cursor-pointer grid-cols-[1.9rem_minmax(0,1fr)] items-center gap-3 rounded-xl px-2 py-1.5 transition ${
              checked ? "border border-emerald-600/30 bg-emerald-50/75 dark:bg-emerald-950/40" : "border border-transparent"
            }`}
          >
            <span className="relative inline-flex h-6 w-6 items-center justify-center">
              <input
                type="radio"
                name={`privacy-visibility-${childKey}`}
                value={value}
                checked={checked}
                onChange={() => setVisibility(value)}
                className="peer absolute inset-0 h-6 w-6 cursor-pointer opacity-0"
              />
              <span className="flex h-5 w-5 items-center justify-center rounded-full border border-slate-300 bg-white transition peer-checked:border-emerald-600 peer-checked:bg-emerald-600 dark:border-slate-600 dark:bg-slate-800">
                {checked ? <span className="h-2 w-2 rounded-full bg-white" /> : null}
              </span>
            </span>

            <span className="min-w-0 truncate text-[0.88rem] font-bold leading-tight text-slate-700 dark:text-slate-200">
              {t(labelKey, { defaultValue: DEFAULT_VISIBILITY_LABELS[value] || value })}
            </span>
          </label>
        );
      })}
    </div>
  </fieldset>
);

export default PrivacyVisibilityCard;
